export default __webpack_public_path__ + "static/media/144.22a1c96a.gif";